




















































































































    import { Component, Vue } from 'vue-property-decorator'
	import * as Reveal from '@/assets/scripts/RevealOnScrollModule'
	import * as ScrollTop from '@/assets/scripts/ScrolltopModule'

    @Component
    export default class Scrolltop extends Vue {

        data() {
            return {
                PageTitle: "Scrolltop"
            }
        }
        mounted() {
			new Reveal.revealOnScrollModule()
			new ScrollTop.ScrollTop()
        }
    }
